/* unplugin-vue-components disabled */import script from "./AboutView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutView.vue?vue&type=script&setup=true&lang=ts"

import "./AboutView.vue?vue&type=style&index=0&id=44b7dd31&lang=less&scoped=true"

import exportComponent from "D:\\openclawprogram\\sdjk123-vue - Copy (2)\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44b7dd31"]])

export default __exports__